import { Component, OnInit } from '@angular/core';
import { Hauler } from '../hauler.model';
import { Subscription } from 'rxjs/Subscription';
import { HaulersService } from '../haulers.service';
import { Query } from '../query.model';
import { QueryService } from '../query.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { AngularFirestoreCollection, AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-haulers-list',
  templateUrl: './haulers-list.component.html',
  styleUrls: ['./haulers-list.component.css']
})
export class HaulersListComponent implements OnInit {
  itemsCollection: AngularFirestoreCollection<any>;
  items: Observable<any[]>;
  haulers: any[];
  subscription: Subscription;
  query: Query;
  subscriptionQuery: Subscription;
  services = {collect: false, treatment: true};

  constructor(private afs: AngularFirestore,  private haulersService: HaulersService, private queryService: QueryService) {
   }

  ngOnInit() {
    this.subscription = this.haulersService.haulersChanged
      .subscribe(
        (haulers: Hauler[]) => {
          this.haulers = haulers;
        });

    // this.haulers = this.haulersService.getHaulers();

    this.haulersService.getItems().subscribe( (haulers) => this.haulers = haulers);

    this.subscriptionQuery = this.queryService.queryChanged
        .subscribe(
          (query: Query) => {
            this.query = query;
          }
        );
    this.query = this.queryService.getQuery();
  }


}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-list/haulers-list.component.ts